import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { getArticleBySlug, getLatestArticles } from '@/mocks/articles';
import { getCategoryBySlug } from '@/mocks/categories';

const articleDetailImages: Record<string, string> = {
  '1': 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20colorful%20shopping%20app%20interface%20with%20warm%20ambient%20lighting%2C%20minimalist%20flat%20lay%20composition%20with%20soft%20pink%20and%20cream%20tones%2C%20clean%20product%20photography%20style%2C%20gentle%20natural%20light%20from%20window%2C%20elegant%20lifestyle%20aesthetic%20with%20subtle%20feminine%20touches&width=1200&height=630&seq=detail-1&orientation=landscape',
  '2': 'https://readdy.ai/api/search-image?query=A%20warm-toned%20customer%20service%20workspace%20setup%20with%20a%20laptop%20showing%20support%20chat%20interface%2C%20phone%20and%20headset%20on%20a%20clean%20desk%2C%20soft%20natural%20lighting%20through%20sheer%20curtains%2C%20minimalist%20and%20professional%20atmosphere%2C%20gentle%20pink%20and%20cream%20color%20palette%2C%20cozy%20and%20trustworthy%20brand%20aesthetic&width=1200&height=630&seq=detail-2&orientation=landscape',
  '3': 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20package%20tracking%20interface%20with%20delivery%20route%20map%2C%20placed%20on%20a%20clean%20wooden%20desk%20with%20a%20cup%20of%20tea%20nearby%2C%20warm%20natural%20morning%20light%2C%20minimalist%20lifestyle%20composition%2C%20soft%20beige%20and%20cream%20tones%2C%20calm%20and%20organized%20atmosphere%2C%20product%20photography%20style&width=1200&height=630&seq=detail-3&orientation=landscape',
  '4': 'https://readdy.ai/api/search-image?query=A%20diverse%20group%20of%20smartphones%20and%20tablets%20displaying%20various%20social%20media%20app%20icons%20on%20their%20screens%2C%20arranged%20on%20a%20warm%20cream-colored%20surface%2C%20soft%20diffused%20lighting%20creating%20gentle%20shadows%2C%20modern%20community%20connection%20concept%2C%20clean%20and%20aspirational%20lifestyle%20aesthetic%2C%20pastel%20pink%20and%20warm%20beige%20tones%2C%20editorial%20flat%20lay%20photography&width=1200&height=630&seq=detail-4&orientation=landscape',
  '5': 'https://readdy.ai/api/search-image?query=A%20vibrant%20shopping%20promotion%20flat%20lay%20with%20gift%20boxes%2C%20discount%20tags%2C%20and%20shopping%20bags%20in%20soft%20pastel%20pink%20and%20gold%20tones%2C%20elegant%20and%20festive%20composition%2C%20warm%20ambient%20lighting%20with%20gentle%20sparkle%20accents%2C%20luxury%20retail%20aesthetic%2C%20clean%20and%20celebratory%20atmosphere%2C%20modern%20e-commerce%20lifestyle%20photography&width=1200&height=630&seq=detail-5&orientation=landscape',
  '6': 'https://readdy.ai/api/search-image?query=A%20clean%20and%20organized%20desk%20setup%20with%20a%20return%20package%20and%20shipping%20label%20ready%20to%20be%20sent%2C%20surrounded%20by%20packing%20materials%20and%20tape%20dispenser%2C%20soft%20window%20light%20creating%20a%20calm%20atmosphere%2C%20minimalist%20e-commerce%20logistics%20concept%2C%20warm%20beige%20and%20cream%20tones%2C%20trustworthy%20and%20reassuring%20brand%20aesthetic%2C%20editorial%20product%20photography&width=1200&height=630&seq=detail-6&orientation=landscape',
  '7': 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20security%20lock%20icon%20on%20screen%2C%20placed%20on%20a%20clean%20light-colored%20desk%20surface%2C%20soft%20natural%20side%20lighting%20creating%20gentle%20shadows%2C%20minimalist%20cybersecurity%20concept%20with%20warm%20tones%2C%20calm%20and%20secure%20atmosphere%2C%20cream%20and%20soft%20gray%20color%20palette%2C%20modern%20editorial%20style%20photography&width=1200&height=630&seq=detail-7&orientation=landscape',
  '8': 'https://readdy.ai/api/search-image?query=A%20bright%20and%20cheerful%20family%20carnival%20scene%20with%20colorful%20balloons%20and%20activity%20booths%20in%20a%20modern%20indoor%20venue%2C%20families%20with%20children%20enjoying%20various%20games%20and%20workshops%2C%20warm%20natural%20light%20flooding%20through%20large%20windows%2C%20joyful%20and%20lively%20atmosphere%2C%20soft%20pastel%20pink%20and%20cream%20color%20scheme%2C%20editorial%20event%20photography%20with%20cinematic%20warmth&width=1200&height=630&seq=detail-8&orientation=landscape',
  '9': 'https://readdy.ai/api/search-image?query=A%20flat%20lay%20of%20various%20payment%20methods%20represented%20by%20smartphone%20screens%20showing%20payment%20interfaces%2C%20next%20to%20a%20wallet%20and%20credit%20cards%2C%20warm%20soft%20lighting%2C%20clean%20minimalist%20composition%2C%20modern%20fintech%20concept%2C%20cream%20and%20soft%20rose%20gold%20tones%2C%20sophisticated%20e-commerce%20aesthetic%2C%20editorial%20product%20photography&width=1200&height=630&seq=detail-9&orientation=landscape',
  '10': 'https://readdy.ai/api/search-image?query=A%20elegant%20membership%20card%20display%20on%20a%20soft%20pink%20gradient%20background%2C%20with%20gold%20accents%20and%20premium%20card%20designs%20layered%20beautifully%2C%20warm%20diffused%20lighting%20creating%20a%20luxurious%20atmosphere%2C%20modern%20brand%20loyalty%20concept%2C%20cream%20and%20rose%20gold%20tones%2C%20sophisticated%20retail%20aesthetic%2C%20high-end%20editorial%20photography%20style&width=1200&height=630&seq=detail-10&orientation=landscape',
  '11': 'https://readdy.ai/api/search-image?query=A%20modern%20open-plan%20office%20space%20with%20a%20large%20screen%20displaying%20strategic%20growth%20charts%20and%20future%20vision%20graphics%2C%20team%20of%20diverse%20professionals%20collaborating%20at%20a%20meeting%20table%2C%20warm%20natural%20light%20through%20windows&width=1200&height=630&seq=detail-11&orientation=landscape',
  '12': 'https://readdy.ai/api/search-image?query=A%20beautifully%20wrapped%20gift%20box%20with%20elegant%20ribbon%20and%20a%20decorative%20gift%20card%20placed%20on%20top%2C%20soft%20pastel%20pink%20background%20with%20subtle%20floral%20elements%2C%20warm%20diffused%20lighting%20from%20above%2C%20luxurious%20gift-giving%20concept&width=1200&height=630&seq=detail-12&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = getArticleBySlug(slug || '');
  const category = article ? getCategoryBySlug(article.category) : null;
  const relatedArticles = article
    ? getLatestArticles(12).filter((a) => a.id !== article.id).slice(0, 3)
    : [];

  if (!article) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-20 pb-20 text-center">
          <h1 className="text-2xl font-bold text-foreground-950">文章不存在</h1>
          <Link to="/" className="text-primary-500 hover:text-primary-600 mt-4 inline-block whitespace-nowrap">
            返回首页
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.summary,
    datePublished: article.date,
    author: {
      '@type': 'Organization',
      name: article.author,
    },
    publisher: {
      '@type': 'Organization',
      name: '蜜芽永不失联',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://yixiaocbw.cn/article/${article.slug}`,
    },
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleJsonLd) }}
      />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main className="pt-20 pb-14">
          <article className="max-w-3xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                ...(category ? [{ label: category.name, href: `/category/${category.slug}` }] : []),
                { label: article.title },
              ]}
            />

            <header className="mb-8">
              {category && (
                <Link
                  to={`/category/${category.slug}`}
                  className="inline-block text-xs px-3 py-1 rounded-full bg-primary-100 text-primary-700 mb-4 hover:bg-primary-200 transition-colors whitespace-nowrap"
                >
                  {category.name}
                </Link>
              )}
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
                {article.title}
              </h1>
              <div className="flex items-center gap-4 mt-4 text-sm text-foreground-500">
                <span>{article.author}</span>
                <span>·</span>
                <span>{article.date}</span>
              </div>
            </header>

            <div className="mb-8 rounded-lg overflow-hidden">
              <img
                src={articleDetailImages[article.id] || articleDetailImages['1']}
                alt={article.title}
                title={`${article.title} - 蜜芽永不失联`}
                className="w-full h-auto object-cover"
              />
            </div>

            <div className="prose prose-sm md:prose-base max-w-none text-foreground-800 leading-relaxed">
              {article.content.split('\n\n').map((paragraph, index) => {
                if (paragraph.startsWith('一、') || paragraph.startsWith('二、') || paragraph.startsWith('三、') || paragraph.startsWith('四、') || paragraph.startsWith('五、')) {
                  return (
                    <h3 key={index} className="text-lg font-semibold text-foreground-950 mt-8 mb-3">
                      {paragraph}
                    </h3>
                  );
                }
                if (paragraph.startsWith('步骤') || paragraph.startsWith('Q：')) {
                  return (
                    <h4 key={index} className="text-base font-medium text-foreground-900 mt-6 mb-2">
                      {paragraph}
                    </h4>
                  );
                }
                return (
                  <p key={index} className="mb-4">
                    {paragraph}
                  </p>
                );
              })}
            </div>

            {relatedArticles.length > 0 && (
              <section className="mt-14 pt-10 border-t border-background-200">
                <h3 className="text-lg font-semibold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                  相关文章
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                  {relatedArticles.map((rel) => (
                    <Link
                      key={rel.id}
                      to={`/article/${rel.slug}`}
                      className="group bg-background-50 rounded-lg p-4 hover:bg-background-100 transition-colors cursor-pointer"
                    >
                      <h4 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                        {rel.title}
                      </h4>
                      <p className="text-xs text-foreground-500 mt-2">{rel.date}</p>
                    </Link>
                  ))}
                </div>
              </section>
            )}
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}